import React, { useEffect, useState } from 'react';
import './App.css';

function Garantie() {
    useEffect(() => { window.scrollTo(0, 0); document.title = 'Garanție | SPCheapCars'; }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    // ── glass helpers ──────────────────────────────────────────────────────────
    const glassDark = {
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        border: '1px solid rgba(255,255,255,0.13)',
        borderRadius: '16px',
    };

    const heroTexture = [
        'repeating-linear-gradient(125deg, transparent 0px, transparent 16px, rgba(255,255,255,0.06) 16px, rgba(255,255,255,0.06) 17px)',
        'repeating-linear-gradient(35deg, transparent 0px, transparent 32px, rgba(255,142,24,0.045) 32px, rgba(255,142,24,0.045) 33px)',
        'radial-gradient(ellipse at 70% 0%, rgba(255,142,24,0.1) 0%, transparent 50%)',
        'linear-gradient(180deg, rgba(28,46,74,0) 0%, rgba(15,26,43,0.5) 100%)'
    ].join(', ');

    const coverageItems = [
        { icon: 'bi-gear-wide-connected', title: 'Motor', desc: 'Componentele motorului sunt acoperite 12 luni de la data achiziției, fără costuri suplimentare.' },
        { icon: 'bi-gear-fill',           title: 'Cutie de Viteze', desc: 'Transmisia este acoperită integral pe durata garanției, indiferent dacă este manuală sau automată.' }
    ];

    const extensionSteps = [
        { num: '1', text: 'Ne contactezi telefonic sau pe WhatsApp' },
        { num: '2', text: 'Alegi durata de extindere potrivită pentru tine' },
        { num: '3', text: 'Semnezi actul adițional la livrarea mașinii' }
    ];

    const conditii = [
        'Respectarea intervalelor de service recomandate de producător',
        'Utilizarea pieselor originale sau echivalente certificate',
        'Prezentarea documentelor de achiziție la solicitarea garanției',
        'Notificarea în termen de 48h de la apariția unui defect'
    ];

    return (
        <div style={{ background: '#f0f4f9', minHeight: '100vh' }}>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 1 — HERO (dark navy)
            ══════════════════════════════════════════════════════════════ */}
            <div className="position-relative page-hero" style={{ background: trustNavy, paddingTop: isMobile ? '32px' : '120px', paddingBottom: isMobile ? '48px' : '80px' }}>
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: heroTexture }}></div>

                <div className="container text-center text-white position-relative">
                    {/* Badge */}
                    <div style={{
                        display: 'inline-block',
                        background: `${primaryOrange}22`,
                        border: `1px solid ${primaryOrange}55`,
                        color: primaryOrange,
                        fontSize: '0.65rem', fontWeight: '700', textTransform: 'uppercase',
                        letterSpacing: '3px', padding: '5px 16px', borderRadius: '40px', marginBottom: '18px'
                    }}>PROTECȚIE PREMIUM</div>

                    <h1 style={{
                        fontWeight: '900', letterSpacing: isMobile ? '1px' : '3px',
                        fontSize: isMobile ? '2rem' : 'clamp(2.2rem, 5vw, 3.5rem)',
                        textTransform: 'uppercase', color: '#ffffff', lineHeight: '1.15', marginBottom: '12px'
                    }}>Garanție Inclusă</h1>

                    <div style={{ width: '50px', height: '3px', background: primaryOrange, margin: '0 auto 16px', borderRadius: '2px' }}></div>

                    <p style={{ opacity: 0.7, maxWidth: '460px', margin: '0 auto 32px', fontSize: isMobile ? '0.95rem' : '1.05rem', lineHeight: '1.7' }}>
                        Fiecare vehicul vine cu garanție conform legislației și raport CarVertical gratuit.
                    </p>

                    {/* Glass stat pills */}
                    <div className="d-flex flex-wrap justify-content-center" style={{ gap: '12px' }}>
                        {[
                            { big: '150+', label: 'Puncte Verificate', icon: 'bi-check2-all' },
                            { big: 'Gratuit', label: 'CarVertical', img: 'carverticallogo.png' },
                            { big: '100%', label: 'Transparență', icon: 'bi-eye-fill' }
                        ].map((s, i) => (
                            <div key={i} style={{ ...glassDark, padding: isMobile ? '12px 20px' : '14px 28px', display: 'flex', alignItems: 'center', gap: '12px', flex: '0 1 auto', minWidth: isMobile ? 'calc(45% - 6px)' : 'auto' }}>
                                {s.img
                                    ? <img src={s.img} alt="" style={{ width: '22px', height: '22px', objectFit: 'contain', filter: 'sepia(1) saturate(3) hue-rotate(350deg) brightness(1.1)' }} />
                                    : <i className={`bi ${s.icon}`} style={{ color: primaryOrange, fontSize: '1.1rem' }}></i>
                                }
                                <div style={{ textAlign: 'left' }}>
                                    <div style={{ color: '#fff', fontWeight: '700', fontSize: isMobile ? '1rem' : '1.15rem', lineHeight: 1 }}>{s.big}</div>
                                    <div style={{ color: 'rgba(255,255,255,0.62)', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.8px', marginTop: '2px' }}>{s.label}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 2 — GARANȚIE 12 LUNI (light)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section">
                <div className="container">
                    <div className="ip-header text-center">
                        <span className="ip-eyebrow">INCLUSĂ ÎN PREȚ</span>
                        <h2 className="ip-title">Garanție 12 Luni Inclusă</h2>
                        <p className="ip-lead">
                            Fiecare mașină vândută vine cu 12 luni de garanție pentru motor și cutia de viteze — fără costuri suplimentare.
                        </p>
                    </div>

                    <div className="row g-3">
                        {coverageItems.map((item, i) => (
                            <div className="col-12 col-md-6" key={i}>
                                <div className="ip-card">
                                    <div className="ip-tile">
                                        <i className={`bi ${item.icon}`}></i>
                                    </div>
                                    <div>
                                        <h6 className="ip-card-title">{item.title}</h6>
                                        <p className="ip-card-text">{item.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="ip-note">
                        <i className="bi bi-info-circle-fill"></i>
                        <p>
                            Garanția standard acoperă exclusiv motorul și cutia de viteze. Sună-ne și îți explicăm deschis ce este și ce nu este inclus.
                        </p>
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 3 — CARVERTICAL + EXTINDERE + CONDIȚII + CTA (dark)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section ip-section--dark">
                <div className="container position-relative">

                    {/* ── CarVertical trust strip ── */}
                    <div className="ip-card-dark d-flex align-items-center gap-3">
                        <img src="/carverticallogo.png" alt="CarVertical"
                            style={{ width: '38px', height: '38px', objectFit: 'contain', flexShrink: 0, filter: 'sepia(1) saturate(3) hue-rotate(350deg) brightness(1.1)' }} />
                        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.88rem', lineHeight: '1.6', margin: 0 }}>
                            Transparență totală: raport <strong style={{ color: '#fff' }}>CarVertical gratuit</strong> la fiecare mașină — istoric de accidente, kilometraj și status juridic verificate.
                        </p>
                    </div>

                    <div className="ip-divider"></div>

                    {/* ── Extindere ── */}
                    <div className="row align-items-center g-4 g-lg-5">
                        <div className="col-12 col-lg-5">
                            <span className="ip-eyebrow ip-eyebrow--dark">OPȚIONAL</span>
                            <h2 className="ip-title ip-title--light">Extinde Durata Garanției</h2>
                            <p className="ip-lead ip-lead--light">
                                Poți prelungi garanția peste cele 12 luni incluse. Acoperirea rămâne aceeași: motor și cutie de viteze. Contactează-ne și îți explicăm opțiunile.
                            </p>
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="ip-card-dark">
                                {extensionSteps.map((s, i) => (
                                    <div key={i} className="ip-list-item align-items-center">
                                        <div className="ip-num">{s.num}</div>
                                        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.88rem', lineHeight: '1.6', margin: 0 }}>{s.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="ip-divider"></div>

                    {/* ── Condiții ── */}
                    <div className="row g-4 align-items-start">
                        <div className="col-12 col-lg-5">
                            <h3 className="ip-title ip-title--light" style={{ fontSize: '1.3rem' }}>Condiții de Garanție</h3>
                            <p className="ip-lead ip-lead--light">Pași simpli pentru ca garanția să rămână valabilă.</p>
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="ip-card-dark">
                                {conditii.map((c, i) => (
                                    <div key={i} className="ip-list-item">
                                        <div className="ip-num">{i + 1}</div>
                                        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.88rem', lineHeight: '1.6', margin: 0 }}>{c}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="ip-divider"></div>

                    {/* ── CTA ── */}
                    <div className="ip-cta-row">
                        <a href="tel:0741811511" className="ip-btn ip-btn--glass">
                            <i className="bi bi-telephone-fill"></i>
                            0741 811 511
                        </a>
                        <a href={'https://wa.me/40741811511?text=' + encodeURIComponent('Salut! Aș dori detalii despre garanția inclusă și opțiunea de extindere.')}
                            target="_blank" rel="noreferrer" className="ip-btn ip-btn--wa">
                            <i className="bi bi-whatsapp"></i>
                            WhatsApp
                        </a>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Garantie;
